import { useState, useEffect } from 'react';
import api from '../../../services/api';

// P1-C — performans karnesi (karar 4: tarayıcı yazdırma sayfası). İki varyant,
// YENİ BE ucu YOK — hepsi mevcut uçlar:
//
// SELF (/performance/report-card/:periodId):
//   GET v1/evaluation-periods/{periodId}          → dönem meta
//   GET v1/my/period-results/{periodId}           → goalsTab/feedbackTab/
//                                                   acknowledgement/finalLevelLabel
//                                                   (Plan 5 Task 2 — finalLevelLabel
//                                                   yalnız BE'nin tebliğ koşulu
//                                                   sağlandığında JSON'da gelir,
//                                                   aksi halde undefined; yorumlar
//                                                   tip düzeyinde HÂLÂ yok — KVKK)
//
// MANAGER/İK (/performance/report-card/:periodId/:employeeId — PM.Read):
//   GET v1/evaluation-periods/{periodId}          → dönem meta
//   GET v1/employees/{employeeId}                 → kimlik
//   GET v1/period-goals?periodId[eq]&employeeId[eq] → hedef sonuçları
//   GET v1/feedback-responses/summary?periodId&employeeId → 360 (yorum+OverallLevel dahil;
//                                                   kapsam dışıysa BE 403 → bölüm boş kalır)
//   GET v1/feedback-responses/summary/history?employeeId → dönem satırı:
//                                                   finalLevelId/finalLevelLabel + acknowledgedAt
//                                                   (Plan 2 Task 8 — eski string finalLevel yerine FK)
//
// Tüm GET'ler skipErrorToast — karne kısmî veriyle de basılabilir (ör. yalnız-A
// dönemde 360 yok); interceptor'ın genel hata toast'ı baskı sayfasında gürültü.
export const useReportCardData = (periodId, employeeId) => {
  const [period, setPeriod] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [goals, setGoals] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [managerExtras, setManagerExtras] = useState(null); // {finalLevelLabel, acknowledgedAt}
  const [acknowledgement, setAcknowledgement] = useState(null);
  const [finalLevelLabel, setFinalLevelLabel] = useState(null); // SELF varyantı — Plan 5 Task 2
  const [notReady, setNotReady] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (!periodId) return undefined;
    let cancelled = false;
    setFetching(true);

    const load = async () => {
      const periodReq = api.get(`/v1/evaluation-periods/${periodId}`, { skipErrorToast: true })
        .then((res) => { if (!cancelled) setPeriod(res.data?.data || null); })
        .catch(() => {});

      if (!employeeId) {
        // SELF varyantı
        const selfReq = api.get(`/v1/my/period-results/${periodId}`, { skipErrorToast: true })
          .then((res) => {
            if (cancelled) return;
            const body = res.data;
            if (body?.status) {
              setGoals(body.data?.goalsTab || null);
              setFeedback(body.data?.feedbackTab || null);
              setAcknowledgement(body.data?.acknowledgement || null);
              setFinalLevelLabel(body.data?.finalLevelLabel || null);
              setNotReady(false);
            } else {
              setNotReady(true);
            }
          })
          .catch(() => { if (!cancelled) setNotReady(true); });
        await Promise.all([periodReq, selfReq]);
      } else {
        // MANAGER/İK varyantı
        const employeeReq = api.get(`/v1/employees/${employeeId}`, { skipErrorToast: true })
          .then((res) => { if (!cancelled) setEmployee(res.data?.data || null); })
          .catch(() => {});
        const goalsReq = api.get('/v1/period-goals', {
          params: { 'periodId[eq]': periodId, 'employeeId[eq]': employeeId, pageSize: 200 },
          skipErrorToast: true,
        })
          .then((res) => {
            if (cancelled) return;
            const r = res.data?.data;
            setGoals(Array.isArray(r) ? r : (r?.data || null));
          })
          .catch(() => {});
        const summaryReq = api.get('/v1/feedback-responses/summary', {
          params: { periodId, employeeId },
          skipErrorToast: true,
        })
          .then((res) => { if (!cancelled && res.data?.status) setFeedback(res.data?.data || null); })
          .catch(() => {});
        const historyReq = api.get('/v1/feedback-responses/summary/history', {
          params: { employeeId },
          skipErrorToast: true,
        })
          .then((res) => {
            if (cancelled) return;
            const items = res.data?.data;
            const row = Array.isArray(items) ? items.find((i) => i.periodId === periodId) : null;
            if (row) setManagerExtras({ finalLevelLabel: row.finalLevelLabel || null, acknowledgedAt: row.acknowledgedAt || null });
          })
          .catch(() => {});
        await Promise.all([periodReq, employeeReq, goalsReq, summaryReq, historyReq]);
      }

      if (!cancelled) setFetching(false);
    };

    load();
    return () => { cancelled = true; };
  }, [periodId, employeeId]);

  return {
    period, employee, goals, feedback, managerExtras, acknowledgement, finalLevelLabel, notReady, fetching,
  };
};

export default useReportCardData;
